import { MeasurementSystem } from '../components/Viewer3d/consts';
import { useViewerStore } from '../context/ViewerContext';

export type LengthUnit = 'mm' | 'cm' | 'inch';
export type WeightUnit = 'g' | 'kg' |'lb';

const DECIMAL_PLACES = 2;

const LENGTH_TO_MM: Record<LengthUnit, number> = {
  mm: 1,
  cm: 10,
  inch: 25.4,
};

const WEIGHT_TO_KG: Record<WeightUnit, number> = {
  g: 1000,
  kg: 1,
  lb: 0.45359237 
};

const fixDecimalDigits = (value: number): number =>
  Number.parseFloat(value.toFixed(DECIMAL_PLACES));

export const convertLength = (
  value: number,
  inputUnit: LengthUnit,
  targetMeasurementSystem: MeasurementSystem | null = useViewerStore.getState().measurementSystem, // if this value is null, converts to mm
): number => {
  const valueMm = value * LENGTH_TO_MM[inputUnit];

  if (targetMeasurementSystem === MeasurementSystem.imperial) {
    return fixDecimalDigits(valueMm / LENGTH_TO_MM.inch);
  }

  return fixDecimalDigits(valueMm);
};

export const convertWeight = (
  value: number,
  inputUnit: WeightUnit,
  targetMeasurementSystem: MeasurementSystem | null = useViewerStore.getState().measurementSystem, // if this value is null, converts to kg
): number => {
  const valueKg = value * WEIGHT_TO_KG[inputUnit];

  if (targetMeasurementSystem === MeasurementSystem.imperial) {
    return fixDecimalDigits(valueKg / WEIGHT_TO_KG.lb);
  }

  return fixDecimalDigits(valueKg);
};

export const convertMmToViewerUnit = (value: number): number =>
  convertLength(value, 'mm');

export const convertUnitToDefault = (value: number, inputUnit: LengthUnit): number => {
  return convertLength(value, inputUnit, null);
}

export const convertKgToViewerUnit = (val: number) => {
  return convertWeight(val, 'kg');
}

export const convertWeightUnitToDefault = (val: number, inputUnit: WeightUnit) => {
  return convertWeight(val, inputUnit, null);
}